// Main application component
// Handles routing, authentication state, and survey management
import React from 'react';
import './App.css';
import NavBar from './components/NavBar';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import SignIn from './pages/SignIn';
import Home from './pages/Home';
import SurveyBuilder from './pages/SurveyBuilder';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SurveyViewer from './components/SurveyViewer';
import Survey from './pages/Survey';
import SurveyAnalyticsPage from './pages/SurveyAnalytics';

// Create router configuration
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <NavBar />
          <div className="container mx-auto py-6">
            <Home />
          </div>
        </div>
      </AuthProvider>
    ),
  },
  {
    path: "/signin",
    element: (
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <NavBar />
          <div className="container mx-auto py-6">
            <SignIn />
          </div>
        </div>
      </AuthProvider>
    ),
  },
  {
    path: "/survey/:id",
    element: (
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <NavBar />
          <div className="container mx-auto py-6">
            <ProtectedRoute>
              <SurveyBuilder />
            </ProtectedRoute>
          </div>
        </div>
      </AuthProvider>
    ),
  },
  {
    path: "/s/:id",
    element: (
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <NavBar />
          <div className="container mx-auto py-6">
            <Survey />
          </div>
        </div>
      </AuthProvider>
    ),
  },
  {
    path: "/surveys/analytics/:id",
    element: <SurveyAnalyticsPage />,
  },
  // Add other routes as needed
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;